



































































import { Component, Watch, Vue } from 'vue-property-decorator';
import UtilityNav from './UtilityNav.vue';

@Component({
  components: {
    UtilityNav,
  },
})
export default class MainNav extends Vue {
  private menuClosed: boolean = true;
  private screenSize: number = screen.width;
  private showMenu: boolean = true;
  private lastScrollPosition: number = 0;
  private showStoreBanner: boolean = false;
  private route: string = '';
  /* TODO: Move data to service */
  private data() {
    return {
      menuLogo: {
        url: require('../.././assets/DD_logo_320x86.png'),
        alt: 'Doc Danko Home',
      },
      gearA: {
        url: require('../../assets/main-nav/mobile/mobile-gear-1.png'),
        alt: 'Gear 1',
        highlight: require('../../assets/main-nav/mobile/mobile-gear-1-high.png'),
        highAlt: 'Gear 1 highlight',
      },
      gearB: {
        url: require('../../assets/main-nav/mobile/mobile-gear-2.png'),
        alt: 'Gear 2',
        highlight: require('../../assets/main-nav/mobile/mobile-gear-2-high.png'),
        highAlt: 'Gear 2 highlight',
      },
    };
  }

  private closeMenu() {
    this.menuClosed = !this.menuClosed;
  }


  @Watch('screenSize')
  private onchange(val: number, oldVal: number) {
    this.screenSize = val;
  }

  private mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });

    document.body.addEventListener('scroll', this.handleScroll);

  }


  private handleScroll() {
    const currentScrollPosition = window.pageYOffset || document.body.scrollTop;
    if (currentScrollPosition < 0) {
      return;
    }
    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 40) {
      return;
    }
    this.showMenu = currentScrollPosition < this.lastScrollPosition;
    this.lastScrollPosition = currentScrollPosition;
  }
}
